import { Forms } from "../../interfaces/forms";

const couponForm: Forms = {
    formHeader: "בדיקת קופון",
    data: [
        {
            name: "couponCode",
            label: "קוד קופון",
            fieldType: "text",
            placeholder: "הכנס שם קופון"
        }
    ]
}
export default couponForm;
